export default (msg, $store) => {
  const { commit } = $store;

  commit('_getCustomerRating', msg);
};
